/* eslint-disable @typescript-eslint/no-var-requires */
// This must run BEFORE any pkarr code executes
(() => {
  // Wait for Buffer to be available from the polyfill
  const originalBuffer = globalThis.Buffer;
  
  Object.defineProperty(globalThis, 'Buffer', {
    get() {
      return originalBuffer;
    },
    set(value) {
      // Add writeBigUInt64BE when Buffer is set
      if (value && !value.prototype.writeBigUInt64BE) {
        value.prototype.writeBigUInt64BE = function(val, offset = 0) {
          const view = new DataView(this.buffer, this.byteOffset, this.byteLength);
          view.setBigUint64(offset, BigInt(val), false);
          return offset + 8;
        };
      }
      return Reflect.set(globalThis, 'Buffer', value);
    },
    configurable: true
  });
})();

